// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"alertItem_wrapper_2Mn1YKC","active":"alertItem_active_3weiwRK"};